module.exports = __webpack_public_path__ + "img/italy-pregnancy-childbirth-and-the-puerperium-female.d81db1f6.png";